import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDoubleDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.8 13.2 12 18l-4.8-4.8M16.8 6 12 10.8 7.2 6"
    />
  </svg>
);
export default SvgChevronDoubleDown;
